/**
 * ResponsavelConfigWhatsapp
 * @author Simpli CLI generator
 */
import {$, Helper, Model, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {StatusSms} from '@/model/resource/StatusSms'
import {StatusWhatsapp} from '@/model/resource/StatusWhatsapp'
import {TipoOcorrencia} from '@/model/resource/TipoOcorrencia'
import {ResponsavelConfigWhatsappCollection} from '@/model/collection/ResponsavelConfigWhatsappCollection'

/* TODO: review generated class */
export class ResponsavelConfigWhatsapp extends Resource {
  idConfigWhatsappPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(StatusSms)
  status: StatusSms | null = null

  @ResponseSerialize(StatusWhatsapp)
  whatsappStatus: StatusWhatsapp | null = null

  @ResponseSerialize(TipoOcorrencia)
  ocorrencia: TipoOcorrencia | null = null

  mensagem: string | null = null
  ativo: boolean | null = null
  templateId: string | null = null

  get $id() {
    return this.idConfigWhatsappPk
  }
  set $id(val) {
    this.idConfigWhatsappPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idStatusFk() {
    if (!this.status) return 0
    return this.status.$id
  }
  set idStatusFk(val) {
    if (!this.status) this.status = new StatusSms()
    this.status.$id = val
  }

  get idWhatsappStatusFk() {
    if (!this.whatsappStatus) return 0
    return this.whatsappStatus.$id
  }
  set idWhatsappStatusFk(val) {
    if (!this.whatsappStatus) this.whatsappStatus = new StatusWhatsapp()
    this.whatsappStatus.$id = val
  }

  get idOcorrenciaFk() {
    if (!this.ocorrencia) return 0
    return this.ocorrencia.$id
  }
  set idOcorrenciaFk(val) {
    if (!this.ocorrencia) this.ocorrencia = new TipoOcorrencia()
    this.ocorrencia.$id = val
  }

  /**
   * Gets a instance of a given ID of ResponsavelConfigWhatsapp
   */
  async getResponsavelConfigWhatsapp(id: number) {
    return await Request.get(`/admin/responsvel-config-whatsapp/${id}`)
      .name('getResponsavelConfigWhatsapp')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of ResponsavelConfigWhatsapp
   */
  async removeResponsavelConfigWhatsapp() {
    return await Request.delete(`/admin/responsvel-config-whatsapp/${this.$id}`)
      .name('removeResponsavelConfigWhatsapp')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelConfigWhatsapp
   */
  static async listResponsavelConfigWhatsapp(params: any) {
    return await Request.get(`/admin/responsvel-config-whatsapp`, {params})
      .name('listResponsavelConfigWhatsapp')
      .as(ResponsavelConfigWhatsappCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelConfigWhatsapp. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelConfigWhatsapp() {
    return await Request.post(`/admin/responsvel-config-whatsapp`, this)
      .name('persistResponsavelConfigWhatsapp')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelConfigWhatsapp to use it in a CSV file
   */
  static async listCsvResponsavelConfigWhatsapp(params: any) {
    return await Request.get(`/admin/responsvel-config-whatsapp/csv`, {params})
      .name('listCsvResponsavelConfigWhatsapp')
      .as(ResponsavelConfigWhatsappCollection)
      .getData()
  }
}
